import { mobilePolicyPrefix } from './consts'

export const mobileIcon = ['fab', 'android']
export const mobileVariant = 'success'

export const desktopIcon = ['fab', 'windows']
export const desktopVariant = 'info'

export const unknownDeviceIcon = 'circle-question'
export const unknownDeviceVariant = 'warning'

// avoid confusing model numbers by translating them
export const knownMobileModelRegistry = {
  'SM-N970F': 'Galaxy Note 10',
  'SM-G960U1': 'Galaxy S9',
}

export function knownMobileModel (model) {
  return (model in knownMobileModelRegistry)
    ? knownMobileModelRegistry[model]
    : model
}

export function isMobile(deviceId) {
  if ([15, 16].includes(deviceId.length)) return true
  if (deviceId.indexOf('.mobiles.vipro') > 0) return true
  return false
}

export function deviceIcon (deviceId) {
  if (isMobile(deviceId)) return mobileIcon
  if (deviceId.indexOf('.users.vipro')) return desktopIcon
  return unknownDeviceIcon
}

export function iconVariation (deviceId) {
  if (isMobile(deviceId)) return mobileVariant
  if (deviceId.indexOf('.users.vipro')) return desktopVariant
  return unknownDeviceVariant
}

export function filterPolicyNames (mobile, policyNames) {
  if (policyNames == null) return null
  return policyNames.filter(v => 
    (mobile && v.indexOf(mobilePolicyPrefix) === 0)
    || (!mobile && v.indexOf(mobilePolicyPrefix) === -1))
}

export function filterPolicyNamesForDevice (deviceId, policyNames) {
  return filterPolicyNames(isMobile(deviceId), policyNames)
}

export function isProjectMobile (project) {
  return (project || '').indexOf(mobilePolicyPrefix) === 0
}

export function filterPolicyNamesForProject (project, policyNames) {
  return filterPolicyNames(isProjectMobile(project), policyNames)
}